"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SummatedComponent_1 = require("./SummatedComponent");
var SummatedComponentStyle_1 = require("../../components/SummatedComponentStyle");
var summatedStyle = SummatedComponentStyle_1.default(true);
var ExplanationComponent = function (props) { return (React.createElement(React.Fragment, null,
    React.createElement("p", null,
        React.createElement("strong", null, "Background")),
    React.createElement("p", null,
        "The ",
        React.createElement("strong", null,
            React.createElement("em", null, "Top-Bonus")),
        " format was used in the IFSC Bouldering World Cups for almost a decade, until 2018. For each boulder problem, there are 2 special holds: a \"bonus\" hold in the middle; a \"top\" hold at the very top."),
    React.createElement("p", null,
        "The difference from its successor, the ",
        React.createElement("em", null, "Top-Zone"),
        " format, would be the emphasis on ",
        React.createElement("abbr", { title: 'Getting to the Top hold in 1 attempt' }, "flashing"),
        " boulder problems. It rewards athletes who can get to the top of the boulder in the fewest attempts, and the \"bonus\" hold is used as a tiebreaker."),
    React.createElement("p", null,
        React.createElement("strong", null, "Explanation")),
    React.createElement("p", null,
        "For the ",
        React.createElement("em", null, "Top-Bonus"),
        " format, climbers will have to reach and achieve stable control of the \"Top\" and \"Bonus\" holds within each problem. Attempts to reach the holds are also recorded, and the order of scoring is:"),
    React.createElement("ol", null,
        React.createElement("li", null, "Most Tops achieved"),
        React.createElement("li", null, "Least attempts to achieve Tops in (1)"),
        React.createElement("li", null, "Most Bonuses achieved"),
        React.createElement("li", null, "Least attempts to achieve Bonuses in (3)")),
    React.createElement("p", null, "The aim is to get the most Tops or Bonuses in the least attempts!"),
    React.createElement("p", null,
        React.createElement("strong", null, "Example")),
    React.createElement("span", null,
        "Climber's result: ",
        React.createElement("em", null,
            React.createElement(SummatedComponent_1.default, { summated: { top: 4, topAttempt: 8, bonus: 6, bonusAttempt: 10, display: '' }, style: summatedStyle }))),
    React.createElement("p", null,
        "For the above result, the climber managed to get a total of 4 Tops ",
        React.createElement("em", null, "(T)"),
        " using 8 attempts, and 6 Bonuses ",
        React.createElement("em", null, "(B)"),
        " using 10 attempts."))); };
exports.default = ExplanationComponent;
//# sourceMappingURL=ExplanationComponent.js.map


//////////////////
// WEBPACK FOOTER
// ../lib-score-systems/dist/scoreSystems/IfscTopBonus/ExplanationComponent.js
// module id = 1027
// module chunks = 0